import React from 'react';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import SectionHeader from '../../CherrySoftware/components/SectionHeader';
import GlassCard from '../../CherrySoftware/components/GlassCard';
import IconBadge from '../../CherrySoftware/components/IconBadge';
import { pain } from '../cherryWebContent';

const Pain = () => {
  const theme = useTheme();

  return (
    <Box py={{ xs: 2, md: 3 }}>
      <SectionHeader
        overline={pain.overline}
        title={pain.title}
        icon="trendingDown"
        align="left"
        maxWidth={720}
      />

      <Grid container spacing={3}>
        {pain.items.map((item) => (
          <Grid item xs={12} md={4} key={item.id}>
            <GlassCard data-aos="fade-up" accentPalette={item.color || 'primary'}>
              <CardContent sx={{ p: 3 }}>
                <Box mb={2}>
                  <IconBadge
                    icon={item.icon}
                    color={item.color || 'primary'}
                    variant="gradient"
                    size={44}
                    rounded="12px"
                  />
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 800, mb: 1.5, lineHeight: 1.3 }}>
                  {item.title}
                </Typography>
                <Typography color="textSecondary" sx={{ lineHeight: 1.75 }}>
                  {item.text}
                </Typography>
              </CardContent>
            </GlassCard>
          </Grid>
        ))}
      </Grid>

      <Box
        data-aos="fade-up"
        mt={4}
        p={{ xs: 3, md: 4 }}
        borderRadius={3}
        bgcolor={alpha(theme.palette.secondary.main, 0.08)}
        border={`1px solid ${alpha(theme.palette.secondary.main, 0.22)}`}
      >
        <Typography
          variant="overline"
          color="secondary"
          sx={{ fontWeight: 800, letterSpacing: 1.2, display: 'block', mb: 1 }}
        >
          La solución
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.55, maxWidth: 820 }}>
          {pain.solution}
        </Typography>
      </Box>
    </Box>
  );
};

export default Pain;
